angular.module 'zc.core'

.directive 'loading', (NotificationChannel) ->
  directive =
    restrict: "A"
    link: (scope, element) ->
      element.addClass("all-filter-remove")
      startRequestHandler = ->
        element.removeClass("all-filter-remove")
      endRequestHandler = ->
        element.addClass("all-filter-remove")
      NotificationChannel.onRequestStarted scope, startRequestHandler
      NotificationChannel.onRequestEnded scope, endRequestHandler
  directive



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/directives/loading.js.coffee